import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import { UserContext } from '../../../UserContext';
import axios from '../../../axios';
import { checkPermiso } from '../../../Utils/PermissionsFunctions';
import Loader from '../../../Layout/Loaders/Loader';
import { BlobProvider } from '@react-pdf/renderer';
import ReporteGlobalPDFDiarioXPersonaEnSucursal from '../PDFs/ReporteGlobalPDFDiarioXPersonaEnSucursal';

const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();
const todayEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString();

const ReporteXDiaSucXPersona = () => {
    const {user} = useContext(UserContext);
    const [dia,setDia] = useState(new Date());
    const [rango,setRango] = useState({field:'fecha_pedido',start:today,end:todayEnd});
    const [ordenes,setOrdenes] = useState([]);
    const [sucursales,setSucursales] = useState([]);
    const [sucursal,setSucursal] = useState(null);
    const [loader,setLoader] = useState(true);
    const [permisos,setPermisos] = useState({
        orders_read:null,
    });

    useEffect(()=>{
        _getSucursales();
        if(user.id){
            setPermisos((prevPremisos) => ({
                ...prevPremisos,
                orders_read:checkPermiso("orders_read",user.permissions)
            })); 
            setRango({...rango,sucursal_id:user.sucursal_id});
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[user]);

    useEffect(()=>{
        setLoader(true);
        if(permisos.orders_read) getPedidos();
    },[permisos, rango]);

    useEffect(()=>{
        if(ordenes.length > 0) setLoader(false);
    },[ordenes]);

    const getPedidos = () =>{
        axios.post("/api/daily-employee-report",rango).then((resp)=>{
            console.log(resp.data);
            setOrdenes(resp.data)
        }).catch(e=>console.log("Error",e))
    }

    const _getSucursales = () =>{
        axios.get('api/sucursals').then((resp)=>{
            setSucursales(resp.data);
        }).catch(e=>console.error("Error ",e));
    }

    const handleDate = (e) => {
        let date =  new Date(e.target.value);
        date.setDate(date.getDate());
        let nextDate = new Date(e.target.value);
        nextDate.setDate(date.getDate()+1);
        //date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
        setDia(nextDate);
        setRango({...rango,start:date,end:nextDate});
    }

    const renderSucursalName = () =>{
        let sucursal = sucursales.find(suc=>suc.id == rango.sucursal_id);
        return sucursal ? sucursal.nombre_sucursal : "";
    }

    return (
        <div>
            <div className='container-admin-menu '> <Breadcrumb hasButton={true} hasFilters={false} /> </div>
            <div className='container-admin-container'>
                <div className='container-admin z-depth-1 row'>
                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' style={{bordeRadius:'10px!important', padding:'0px!important',}}>
                        <div className="col s12 m6 p-0">
                           <h5>Reporte Global Diario X Persona en Sucursal - {renderSucursalName()}</h5>
                           <div>Fecha Analisis:  {dia.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })} </div>
                        </div>
                        <div className="row col s12 m6 input-text">
                        <div className='col s12 m4 m-p-0 centrar'>
                            {!loader &&
                                <BlobProvider document={<ReporteGlobalPDFDiarioXPersonaEnSucursal ordenes={ordenes}  fileName="Reporte_Global_Diario_Por_Persona_En_Sucursal.pdf"/>}>
                                {({url}) => (
                                    <a className="btn-blanco puntero" style={{marginTop:15}} href={url} target="_blank" rel="noreferrer">
                                        <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/pdf-reporte.png' alt='reporte PDF' style={{width:'20px'}} />
                                        <span className='centrar'> &nbsp;&nbsp;Descargar PDF </span>
                                    </a>
                                )}
                                </BlobProvider>
                                
                            }
                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Selecciona una sucursal</label>
                                <select className='browser-default' style={{maxHeight:30}} onChange={(e)=>setRango({...rango,sucursal_id:e.target.value})} value={rango.sucursal_id}>
                                    <option value="" disabled selected>Selecciona una sucursal</option>
                                    {sucursales.map((suc) =>
                                        <option value={suc.id}  key={suc.id}>{suc.nombre_sucursal}</option>
                                    )}
                                </select>

                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Seleccionar día</label>
                                <input id="dia" type="date" onChange={handleDate}/>
                            </div>
                        </div>
                    </div>
                   
                    <div className='col m12 row m-t-10 z-depth-1 p-10 border-r-6'>
                        {!loader ? 
                            ordenes.map((orden,index)=>
                                <>
                                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' 
                                    style={{backgroundColor:'#ffffff', border:'solid 1px #11cdef', color:'#11cdef', bordeRadius:'10px!important', padding:'0px!important',}} index={index}>
                                        <h5 className='m-p-0'>Atendido por: {orden.persona.empleado_name} </h5>
                                    </div>
                                    <div className="col m12 container p-10 table table-doc">
                                        {orden.ordenes.map((item,i)=>
                                            <div className=' p-t-15'>
                                                <div className='row m-p-0' 
                                                style={{display:'flex', borderTop:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Fecha:</label><br/>
                                                       {item.fecha_pedido}
                                                    </div>
                                                    <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Doctor:</label><br/>
                                                        {item?.doctor?.nombre +' '+ item?.doctor?.apellidos}
                                                    </div>
                                                    <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Paciente:</label><br/>
                                                        {item.patient.nombre}
                                                    </div>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>ID Pedido:</label><br/>
                                                        {item.id}
                                                    </div>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Pago:</label><br/>
                                                        ${item.order_payment.total}
                                                    </div>
                                                </div>
                                                <div className='row m-p-0'
                                                style={{display:'flex', borderBottom:'solid 1px #3c4d69', borderLeft:'solid 1px #3c4d69', borderRight:'solid 1px #3c4d69'}}>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Metodo:</label><br/>
                                                        {item.order_payment.metodo_de_pago}
                                                    </div>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Importe:</label><br/>
                                                        ${item.order_payment.total}
                                                    </div>
                                                    <div className='col s12 m2' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Anticipo:</label><br/>
                                                        ${item.order_payment.anticipo1}
                                                        {Number (item.order_payment.anticipo2) > 0? '$'+item.order_payment.anticipo2: ''}
                                                        {Number (item.order_payment.anticipo3) > 0? '$'+item.order_payment.anticipo3: ''}
                                                    </div>
                                                    <div className='col s12 m6' style={{border:'solid 1px #cdcdcd'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Estudios:</label>
                                                        <ul className='m-p-0'>
                                                            {item.order_details.map((ele)=> 
                                                                <li key={ele.product.id}> - {ele.product.nombre_producto} </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className=' p-t-15'></div>

                                        <div className='m-p-0 table-container'>
                                            <div className='row m-p-0'>
                                                <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                    <div style={{border:'solid 4px #e8f0fe'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Pedidos Atendidos:</label><br/>
                                                        {orden.persona.total_pedidos}
                                                    </div>
                                                </div>
                                                <div className='col s12 m6' style={{border:'solid 1px #cdcdcd'}}>
                                                    <div style={{border:'solid 4px #e8f0fe'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Atendidos por:</label><br/>
                                                        {orden.persona.empleado_name}
                                                    </div>
                                                </div>
                                                <div className='col s12 m3' style={{border:'solid 1px #cdcdcd'}}>
                                                    <div style={{border:'solid 4px #e8f0fe'}}>
                                                        <label htmlFor="dia" style={{fontSize:10, color:'blue'}}>Total del Corte:</label><br/>
                                                        ${orden.persona.total}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                            :
                            <Loader />
                        }
                       
                    </div>
                </div> 
            </div> 
        </div>
    );
};

export default ReporteXDiaSucXPersona;